import * as yup from "yup";
import { validationNotEmpty, } from "./defaultValidations";

export default yup.object({
  hostname: validationNotEmpty("Hostname"),
  hostIp: validationNotEmpty("Host IP"),
  licenseType: validationNotEmpty("License Type"),
  licenseString: validationNotEmpty("License String"),
});